<template lang="pug">
  .input_money
    input-text(
      :id="inputKey"
      :prefix="prefix"
      :label="label"
      v-model="valueData"
      :disabled="disabled"
      :style="getPrefixColor"
      :maxlength="maxlength"
      :required="required"
      :rules="rules"
      v-bind="$attrs"
      @input="formatNumber($event)"
      @keypress="onlyNumber($event)"
    )
</template>

<script>
import InputMoneyAndPercentageMixin from 'Support/mixins/InputMoneyAndPercentageMixin';

export default {
  name: 'InputMoney',
  mixins: [InputMoneyAndPercentageMixin],
  props: {
    label: {
      type: String,
      default: 'Input money',
    },
    prefix: {
      type: String,
      default: 'R$',
    },
  },
  methods: {
    replaceNumber(value) {
      let v = value.toString();

      v = v.replace(/^0+/, '');

      v = v.replace(/\D/g, '');

      v = v.replace(/(\d{1,2})$/, `${this.separator}$1`);

      v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

      if (v[0] === ',') {
        v = `0${v}`;
      }

      return v;
    },
  },
};
</script>

<style lang="stylus">
  .input_money
    .v-text-field--outline .v-text-field__prefix
      margin-top 0
</style>
